export default __webpack_public_path__ + "static/media/thumbnail-learn.30814cde.jpg";